import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';

// Our API returns dates either in timestamps or in UTC

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

// the timezone on the user's machine
const guessedTimezone = dayjs.tz.guess();

// returns the date in the local timezone
export function formatDateWithLocalTimezone(
  date: string | number,
  format = 'M/D/YYYY',
) {
  const parsedDate = dayjs.utc(date).tz(guessedTimezone);
  if (!parsedDate.isValid()) {
    return null;
  }
  return parsedDate.format(format);
}
